import React, { FC } from 'react';
import { Button, Text } from '../../../../../components/common';
import styles from './ActionItem.scss';
import { IOuter } from './ActionItem.types';

export const ActionItem: FC<IOuter> = ({ icon, label, onClick, dataHook }) => {
  return (
    <div className={styles.actionItemButton} data-hook={dataHook}>
      <Button skin="light" prefixIcon={icon} onClick={onClick} dataHook="action-item" size="small">
        <Text weight="thin" size="small" skin="primary">
          {label}
        </Text>
      </Button>
    </div>
  );
};
